import { render, staticRenderFns } from "./country-settings.vue?vue&type=template&id=63cd388b"
import script from "./country-settings.vue?vue&type=script&lang=ts"
export * from "./country-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports